import { type Translationtype } from "utils";
import Link from "next/link";

interface IAiBudgetExhaustedBannerProps {
  t: Translationtype;
  pendingAiPhotoCount: number;
  cost: number;
  aiBudgetUsd: number;
}

export function AiBudgetExhaustedBanner({
  t,
  pendingAiPhotoCount,
  cost,
  aiBudgetUsd,
}: IAiBudgetExhaustedBannerProps) {
  const isBudgetExhausted = aiBudgetUsd > 0 && cost >= aiBudgetUsd;

  if (!isBudgetExhausted || pendingAiPhotoCount <= 0) {
    return null;
  }

  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 mb-4 rounded-r-lg flex items-center justify-between">
      <p className="text-sm font-medium">
        {t("Global.aiBudgetExhausted", { count: pendingAiPhotoCount })}
      </p>
      <Link
        href="/manageMagicAI"
        className="ml-4 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded-full text-sm whitespace-nowrap"
      >
        {t("Global.topUpAI")}
      </Link>
    </div>
  );
}
